export default {
  video: {
    hero: {
      eyebrow: 'المراقبة بالفيديو',
      title: 'مراقبة بالفيديو تناسب ممتلكاتك',
      subtitle: 'حسب متطلبات المشروع، تعتمد SSG Signaltechnik من بين أمور أخرى على أنظمة مجرّبة من Hikvision وSafire. ويمكن أيضًا تخطيط وتوريد حلول من مصنّعين آخرين معروفين بشكل فردي.',
      ctaPrimary: 'اطلب استشارة أولى مجانية',
      ctaSecondary: 'ابدأ مخطط الكاميرات',
    },
    cameraTypes: {
      eyebrow: 'أنواع الكاميرات',
      title: 'كاميرا الأمان المناسبة لكل استخدام',
      lead: 'ليست كل كاميرا أمان مناسبة لكل مبنى. نختار معًا النوع الصحيح – من كاميرا الدوم المدمجة إلى PTZ الآلية.',
      items: {
        '0': { name: 'كاميرات دوم', tag: 'داخلي وخارجي', desc: 'شكل نصف كروي سري للتركيب في السقف. مقاومة للتخريب وغير لافتة – مثالية للتجزئة والمكاتب والمناطق العامة.', features: { '0': 'تركيب سقفي غير لافت', '1': 'مقاومة للتخريب (IK10)', '2': 'توجيه يدوي 360°' } },
        '1': { name: 'كاميرات رصاصية', tag: 'خارجي', desc: 'شكل أسطواني كلاسيكي للتركيب على الجدار أو العمود. مدى طويل ومقاومة للعوامل الجوية مع أثر ردع واضح.', features: { '0': 'مدى مراقبة طويل', '1': 'مقاومة للعوامل IP67', '2': 'ردع واضح' } },
        '2': { name: 'كاميرات توريت', tag: 'خارجي', desc: 'شكل توريت مدمج بدون قبة. انعكاسات أقل من الدوم وأكثر متانة من الرصاصية – الحل المتكامل المثالي.', features: { '0': 'لا انعكاسات للقبة', '1': 'مدمجة ومتينة', '2': 'رؤية ليلية ممتازة' } },
        '3': { name: 'كاميرات PTZ', tag: 'مساحات كبيرة', desc: 'كاميرات إمالة وتدوير وتقريب آلية للمساحات الكبيرة. تحكم عن بُعد عبر التطبيق ومواضع مسبقة وجولات تلقائية.', features: { '0': 'تدوير/إمالة/تقريب آلي', '1': 'جولات تلقائية', '2': 'تحكم عن بُعد عبر التطبيق' } },
        '4': { name: 'كاميرات بانورامية', tag: 'زاوية واسعة', desc: 'تغطية 180° أو 360° بكاميرا واحدة. مثالية للقاعات الكبيرة والاستقبال والغرف المربعة.', features: { '0': 'تغطية 180°/360°', '1': 'تصحيح في المسجّل', '2': 'كاميرا واحدة بدل أربع' } },
        '5': { name: 'كاميرات الرؤية الليلية', tag: 'إضاءة منخفضة', desc: 'تقنية خاصة نهار/ليل ولون ليلي. صور حادة حتى في الظلام – بالأشعة تحت الحمراء أو حتى بالألوان.', features: { '0': 'رؤية ليلية بالأشعة تحت الحمراء', '1': 'خيار اللون الليلي', '2': 'تقنية Starlight' } },
      },
    },
    services: {
      eyebrow: 'الخدمات',
      title: 'أكثر من مجرد تركيب كاميرات',
      lead: 'من الفكرة الأولى حتى العناية المستمرة – نرافق مشروعك في كل خطوة.',
      items: {
        '0': { title: 'الاستشارة وتحليل الاحتياج', desc: 'نناقش أهدافك ونحلل مبنىك ونحدد مناطق المراقبة المثلى – بما في ذلك فحص النقاط العمياء.' },
        '1': { title: 'تخطيط مواضع الكاميرات', desc: 'يتم تخطيط كل موضع: الزاوية وارتفاع التركيب والمسافة وظروف الإضاءة والتمديدات.' },
        '2': { title: 'تركيب احترافي', desc: 'تركيب نظيف وتمديدات احترافية وربط شبكة صحيح وممرات محمية للتركيب الخارجي.' },
        '3': { title: 'المسجّل والتسجيل', desc: 'مسجّل شبكة (NVR) بسعة قرص مناسبة. تخزين محلي لتسجيلاتك حسب تعليماتك.' },
        '4': { title: 'التطبيق والوصول عن بُعد', desc: 'عرض مباشر وإعادة تشغيل وإشعارات على هاتفك. نُعدّ التطبيق ونشرح لك طريقة الاستخدام.' },
        '5': { title: 'الصيانة والعناية', desc: 'اختياريًا مع SSG Care: فحوصات دورية وتحديثات للبرامج الثابتة ودعم وخدمة في الموقع.' },
      },
    },
    tech: {
      eyebrow: 'التقنية',
      title: 'ما يهم عند اختيار الكاميرا',
      lead: 'الميجابكسل وحدها لا تكفي. يجب النظر إلى الزاوية والمسافة والدقة والإضاءة وارتفاع التركيب ومستوى التفاصيل معًا.',
      imageCaption: 'تخطط SSG Signaltechnik كل موضع بشكل فردي – بما يناسب مبنىك ومتطلباتك.',
      items: {
        '0': { title: 'الدقة ومستوى التفاصيل', desc: 'من Full HD إلى 4K – نختار الدقة المناسبة حسب المسافة ومستوى التعرف.' },
        '1': { title: 'داخلي أو خارجي', desc: 'فئات الحماية IP ودرجة حرارة التشغيل وجودة المواد تحدد الاختيار.' },
        '2': { title: 'الضوء وظروف الليل', desc: 'Starlight أو الأشعة تحت الحمراء أو اللون الليلي – التقنية المناسبة لكل حالة.' },
        '3': { title: 'زاوية الرؤية والعدسة', desc: 'بُعد بؤري ثابت أو متغير أو آلي، حسب المنطقة والتفاصيل المطلوبة.' },
        '4': { title: 'التخزين والحفظ', desc: 'NVR محلي مع تخزين مكرر على القرص. مدة الحفظ قابلة للتخطيط.' },
        '5': { title: 'قابلية التوسعة', desc: 'يمكن عادةً توسعة الأنظمة الحالية بكاميرات إضافية – نتحقق من التوافق.' },
      },
    },
    banner: {
      title: 'جودة يمكن الاعتماد عليها',
      lead1: 'تعمل SSG Signaltechnik بشكل أساسي بكاميرات وأنظمة Safire وHikvision – علامتان رائدتان في المراقبة الاحترافية. تمثل Safire الجودة الأوروبية وكتالوجًا واسعًا وضمانًا للمصنّع لمدة 5 سنوات.',
      lead2: 'يمكن أيضًا تخطيط حلول من مصنّعين معروفين آخرين. نختار التقنية التي تناسب مشروعك.',
      badge: '5 سنوات',
      badgeSub: 'ضمان المصنّع على منتجات Safire',
    },
    cta: {
      title: 'لنناقش مشروعك',
      lead: 'كل مبنى يختلف عن الآخر. نجد معًا المزيج المناسب من الكاميرات والمسجّل والملحقات.',
      primary: 'استفسر دون التزام',
      secondary: 'اكتشف الحلول',
    },
  },
};